import { ErrorBoundary } from '@packages/shared';
import { Dialog, type DialogProps } from '@packages/shared/src/ui/Dialog/Dialog';
import { ClickAwayListener } from '@packages/shared/src/ui/ClickAwayListener/ClickAwayListener';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import { useIntl } from 'react-intl';
import { Suspense } from 'react';

import { installmentCalulatorMessages } from '../messages';
import type { InstallmentCalculatorProps } from '../InstallmentCalculator';
import { InstallmentCalculatorErrorFallback } from '../../utils/InstallmentCalculatorErrorFallback';
import { InstallmentCalculatorSuspenseFallback } from '../../utils/InstallmentCalculatorSuspenseFallback';
import { LazyCalculator } from '../../utils/LazyCalculator';

type InstallmentCalculatorDialogProps = DialogProps & Omit<InstallmentCalculatorProps, 'layout'>;

export const InstallmentCalculatorDialog = ({
  basePrice,
  hasEditablePrice,
  source,
  ...dialogProps
}: InstallmentCalculatorDialogProps) => {
  const { formatMessage } = useIntl();
  return (
    <Dialog {...dialogProps} className="w-full">
      <ClickAwayListener onClickAway={dialogProps.onClose}>
        <DialogHeader onClose={dialogProps.onClose}>
          {formatMessage(installmentCalulatorMessages.Headline)}
        </DialogHeader>
        <DialogContent>
          <ErrorBoundary
            fallback={(reset) => <InstallmentCalculatorErrorFallback onCloseHandler={reset} />}
          >
            <Suspense
              fallback={<InstallmentCalculatorSuspenseFallback calculatorLayout="Columns" />}
            >
              <LazyCalculator
                basePrice={basePrice}
                hasEditablePrice={hasEditablePrice}
                source={source}
                layout="Columns"
              />
            </Suspense>
          </ErrorBoundary>
        </DialogContent>
      </ClickAwayListener>
    </Dialog>
  );
};
